import React, {FC, useEffect} from 'react';
import {useAppSelector} from "../store/store";
import {RouteDescriptor} from "../config/acl/routes/RouteDescriptor";
import {Navigate} from "react-router-dom";
import {roles} from "../config/acl/roles";
import {Route} from "../config/acl/routes/Route";
import {Role} from "../config/acl/roles/Role";
import {pathFromRoute} from "../utils/helpers/acl/pathFromRoute";
import {useIntl} from "react-intl";

const FORCE_LOGOUT_FLAG_KEY = 'showForceLogoutModal';

type Props = {
  route: RouteDescriptor<any>
}

export const ACL: FC<Props> = ({route}) => {
  const intl = useIntl();
  const {role} = useAppSelector(state => state.auth);
  const Page = route.render;

  useEffect(() => {
    document.title = intl.formatMessage(route.title);
  }, [route]);

  // If force logout flag is set, redirect to login instead of 404
  const hasForceLogoutFlag = sessionStorage.getItem(FORCE_LOGOUT_FLAG_KEY) === 'true';

  if (route.allowRoles.some(r => r === role)) {
    return (
      <React.Suspense fallback={null}>
        <Page/>
      </React.Suspense>
    );
  }

  if (route.redirectToHomeRoles.some(r => r === role)) {
    return <Navigate to={pathFromRoute(roles[role].homeRoute)} replace={true}/>;
  }

  // If user is guest (logged out) and doesn't have access, redirect to login instead of 404
  // This handles both force logout and regular logout cases
  if (role === Role.guest || hasForceLogoutFlag) {
    return <Navigate to={pathFromRoute(Route.login)} replace={true}/>;
  }

  return <Navigate to={pathFromRoute(Route.notFound)} replace={true}/>;
};
